
import { useEffect, useState } from 'react';

import moment from 'moment';

import { RouteComponentProps, useLocation, withRouter } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { Base64 } from 'js-base64';

import { CondoDetailsWrapper, HotelDetailsWrapper } from '@components';
import { getTimeout, UrlUtils, scrollTop, getAccountUsernameFromPath, getNormalizedRoomsResponse, Responsive } from '@share/utils';
import { ILocation, IRoom, ISessionKey, TRAVCODING_V2 } from '@share/common-types';
import { CONDO_SESSION_KEY, Routes, SESSION_KEY_LABEL } from '@share/constants';
import { condosActions, condosLocationPickerActions, condoStrictDatesActions, datesActions, ILoginState, locationActions, roomsActions } from '@share/store/slices';

import { DashboardHotel } from '../dashboard-hotel';

const zero = 0;

interface IMapStateToProps {
  loginStore: ILoginState;
}

interface IMapDispatchToProps {
  setRooms: (rooms: IRoom[]) => void;
  setDatesSelected: (dates: { startDate: string; endDate: string }) => void;
  setSelectLocation: (location: ILocation) => void;
  setSelectLocationLabel: (label: string) => void;
  applyDates: () => void;
  applyRooms: () => void;
  applyLocation: () => void;
  selectLocationLabel: (label: string) => void;
  setStrictDates: (dates: { startDate: string; endDate: string }) => void;
  setIsFocusDatePicker: (bool: boolean) => void;
}

interface IProps extends IMapDispatchToProps, RouteComponentProps {
  type: string;
}

function StaticDetailPageComponent(props: IProps) {
  const locationHook = useLocation();
  const login = useSelector((state: IMapStateToProps) => state.loginStore);
  const [loading, setLoading] = useState(true);
  const [isHotel, setIsHotel] = useState<boolean>(props.type === 'hotel');
  const [isV2, setIsV2] = useState<boolean>(login.account?.homePageTemplate === TRAVCODING_V2);

  useEffect(() => {
    scrollTop();
    const values = UrlUtils.getValues();
    const routeSearch = isHotel ? Routes.Search : Routes.CondoSearch;
    const sessionKey = isHotel ? SESSION_KEY_LABEL : CONDO_SESSION_KEY;

    const session: ISessionKey = values[sessionKey] as ISessionKey;
    if ((session && session.expireDate && getTimeout(session.expireDate) <= zero)) {
      const accountName = getAccountUsernameFromPath(props.history);
      history.replaceState(null, null, `/${accountName}${routeSearch}${location.search}`);
      location.reload();
    }
    else if (isEmpty(values)) {
      const id = props.match.params.id;
      let name = props.match.params.name;
      const date = new Date();
      const startDate: any = moment(date.setDate(date.getDate() + 1)).format('yyyy-MM-DDT00:00:00');
      if (isHotel && !isV2) {
        const locationObject: any = { "code": id, "name": name }
        props.setSelectLocationLabel(name);
        props.setSelectLocation(locationObject);

        const rooms: any[] = [{ adultsCount: 2, kids: [] }];
        props.setRooms(getNormalizedRoomsResponse(rooms));

        const endDate: any = moment(date.setDate(date.getDate() + 3)).format('yyyy-MM-DDT00:00:00');
        props.setDatesSelected({ startDate: startDate, endDate: endDate });

        props.applyDates();
        props.applyRooms();
        props.applyLocation();
      }
      else if (isHotel && isV2) {
        const checkIn = moment(date).add(1, 'd').format('yyyy-MM-DDThh:mm:ss.000Z');
        const checkOut = moment(checkIn, 'yyyy-MM-DD').add(3, 'd').format('yyyy-MM-DDThh:mm:ss.000Z');
        const dateObject = { checkIn, checkOut };
        const roomsObject = [{ adultsCount: 2, kidsAges: Array(0).fill(0) as number[] }];
        const locationName = name.replaceAll('-', ' ');
        locationHook.search =
          `?dates=${Base64.encode(JSON.stringify(dateObject),
          )}&rooms=${Base64.encode(JSON.stringify(roomsObject),
          )}&location=${Base64.encode(JSON.stringify({ code: id, name: locationName }),
          )}&sessionKey=${Base64.encode(JSON.stringify({}))}`;
      }
      else {
        const endDate: any = moment(date.setDate(date.getDate() + 7)).format('yyyy-MM-DDT00:00:00');
        props.setStrictDates({ startDate, endDate });
        props.selectLocationLabel(name);
        props.setIsFocusDatePicker(true);
      }
    }

    setLoading(false);
  }, []);

  return (
    <>
      {loading ? null :
        isHotel
          ? <div className="hotel-details-page">
            {isV2 ? <DashboardHotel /> : <HotelDetailsWrapper isVacationRentals={false} isStaticDetail={true} />}
          </div>
          : <div className="condo-details-page"><Responsive><CondoDetailsWrapper isStaticDetail={true} /></Responsive></div>
      }
    </>
  );
}

const mapDispatchToProps: IMapDispatchToProps = {
  setRooms: roomsActions.setRooms,
  setDatesSelected: datesActions.setDatesSelected,
  setSelectLocationLabel: locationActions.setSelectLocationLabel,
  setSelectLocation: locationActions.setSelectLocation,
  applyDates: datesActions.applyDates,
  applyRooms: roomsActions.applyRooms,
  applyLocation: locationActions.applyLocation,
  selectLocationLabel: condosLocationPickerActions.selectLocationLabel,
  setStrictDates: condoStrictDatesActions.setDates,
  setIsFocusDatePicker: condosActions.setIsFocusDatePicker,
};

export const StaticDetailPage = connect(null, mapDispatchToProps)(withRouter(StaticDetailPageComponent));